/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Address_MaxInputs */

const vi_validation_address_max = /** @type {(inputs: Validation_Address_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ tối đa 500 ký tự`)
};

/**

* @param {Validation_Address_MaxInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const validation_address_max = /** @type {((inputs?: Validation_Address_MaxInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Address_MaxInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_validation_address_max(inputs)
});